'use strict'

import * as types from './types';

export const setList = ({ date, locations }) => ({
	type: types.SET_LIST,
	data: { date, locations },
});

export const selectAll = () => ({
	type: types.SELECT_ALL,
});

export const unselectAll = () => ({
	type: types.UNSELECT_ALL,
});

export const toggleSelect = index => ({
	type: types.TOGGLE_SELECT,
	data: index,
});

export const reorderAssigned = (dragIndex, hoverIndex) => ({
	type: types.REORDER_ASSIGNED,
	data: {
		dragIndex,
		hoverIndex
	}
});

export const moveSelection = (direction) => ({
	type: types.MOVE_SELECTION,
	data: {
		direction,
	}
});

export const postReverseSelection = (username, date, selectedIndices) => ({
	type: types.POST_REVERSE_SELECTION,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/postReverseSelection`,
		method: 'POST',
		body: { username, date, selectedIndices }
	}
});

export const postOptimizeRoute = (username, date, selectedIndices) => ({
	type: types.POST_OPTIMIZE_ROUTE,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/optimizeRoute`,
		method: 'POST',
		body: { username, date, selectedIndices }
	}
});

export const postFlagIncrement = (username, date, index) => ({
	type: types.POST_FLAG_INCREMENT,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/flagIncrement`,
		method: 'POST',
		body: { username, date, index },
		byPassLoading: true,
	}
});

export const postPriorityIncrement = (username, date, index) => ({
	type: types.POST_PRIORITY_INCREMENT,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/priorityIncrement`,
		method: 'POST',
		body: { username, date, index },
		byPassLoading: true,
	}
});

export const postDeleteLocations = (username, date, selectedIndices) => ({
	type: types.POST_DELETE_LOCATIONS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/deleteLocations`,
		method: 'POST',
		body: { username, date, selectedIndices },
	}
});

export const postAssignNextDay = (username, date, selectedIndices) => ({
	type: types.POST_ASSIGN_NEXT_DAY,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/postAssignNextDay`,
		method: 'POST',
		body: { username, date, selectedIndices }
	}
});

export const postReorderedLocations = (username, date, locations) => ({
	type: types.POST_REORDERED_LOCATIONS,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/postReorderedLocations`,
		method: 'POST',
		body: { username, date, locations },
		params: { username, date },
	},
});

export const postCacheRoutes = (username, date, routes) => ({
	type: types.POST_CACHE_ROUTES,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/cacheRoutes`,
		method: 'POST',
		body: { routes }
	}
});

export const postAddToRoute = ({
	method,
	username,
	date,
	placeId,
	companyId,
	locationId,
	task,
	recipient,
	index
}) => ({
	type: types.POST_ADD_TO_ROUTE,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/postAddToRoute`,
		method: 'POST',
		body: {
			method,
			placeId,
			locationId,
			companyId,
			task,
			recipient,
			index,
		},
		params: { username, date },
	}
});
